import React, {Component} from "react";
import {connect} from "react-redux";
import {ActionCreator} from "../../../../actions/actions";
import {HallsActionCreators} from "../../actions/actionCreators";
import {HallBaseConfig} from "../../reducers/hallsList.reducer";
import {hallsStoreSelectors} from "../../store/store";
import "./HallsListContainer.component.scss";
import HallsListPage from "./HallsListPage/HallsListPage.component";
import {HallsListFilters} from "../../reducers/hallsListFilters.reducer";
import {STARTING_PAGE, PAGE_SIZE} from "./../../reducers/hallsList.reducer";

export interface HallsListProps {
    getHallsList: ActionCreator;
    getSubsidiaries: ActionCreator;
    clearFilters: ActionCreator;
    hallsList: HallBaseConfig[];
    hallsCount: number;
    hallsListLoading: boolean;
    hallsFilters: HallsListFilters;
    lastRefresh: number;
    filters: HallsListFilters;
    subsidiaryLoading: boolean;
}

export interface HallsListContainerState {
    currentPage: number;
}

class HallsListContainer extends Component<
    HallsListProps,
    HallsListContainerState
> {
    constructor(props: HallsListProps) {
        super(props);

        this.state = {
            currentPage: STARTING_PAGE
        };
    }

    componentDidMount() {
        this.getHallsList();
        this.props.getSubsidiaries();
    }

    getHallsList = (searchString = null) => {
        this.props.getHallsList({
            page: this.state.currentPage,
            top: PAGE_SIZE,
            search: searchString ? searchString : this.props.hallsFilters
                ? this.props.hallsFilters.search
                : null,
            filters: this.props.hallsFilters
        });
    }
    onRefresh = () => {
        this.setState({currentPage: STARTING_PAGE});
        this.getHallsList();
    };

    onSearch = searchString => {
        this.getHallsList(searchString);
    };

    onPageChange = (currentPage, update = true) => {
        this.setState({currentPage: currentPage - 1}, () => {
            if (update) {
                this.getHallsList()
            }
        });
    };

    render() {
        return (
            <HallsListPage
                hallsList={this.props.hallsList}
                onSearch={this.onSearch}
                onPageChange={this.onPageChange}
                onRefresh={this.onRefresh}
                loading={
                    this.props.hallsListLoading || this.props.subsidiaryLoading
                }
                lastRefresh={this.props.lastRefresh}
                hallsCount={this.props.hallsCount}
                pageSize={PAGE_SIZE}
                filters={this.props.filters}
                current_page={this.state.currentPage}
            />
        );
    }
}

const mapStateToProps = state => ({
    hallsList: hallsStoreSelectors.hallsList(state),
    hallsCount: hallsStoreSelectors.hallsCount(state),
    hallsListLoading: hallsStoreSelectors.hallsListLoading(state),
    hallsFilters: hallsStoreSelectors.filters(state),
    lastRefresh: hallsStoreSelectors.hallsListTimestamp(),
    filters: hallsStoreSelectors.filters(state),
    subsidiaryLoading: hallsStoreSelectors.subsidiaryLoading(state)
});

const mapDispatchToProps = {
    getHallsList: HallsActionCreators.getHallsList,
    getSubsidiaries: HallsActionCreators.getSubsidiaries,
    clearFilters: HallsActionCreators.clearHallListFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(HallsListContainer);
